module.exports = __webpack_public_path__ + "static/media/pointBadgeLevel4Locked.ef320218.png";